import { StyleSheet } from 'aphrodite';
import { hexToRGBA } from '../../../../../models/UiUtils';
import { borderColor, brandPrimary, charmGray, destructive, titles, white } from '../../../../../web/styles/colors';
import { BreakPoints, CssSelectors } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	additionalQuestions: {
		paddingTop: 20,
	},
	questionsWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		padding: '0 20px',
		margin: '0 auto',
		boxSizing: 'border-box',
		overflowY: 'auto',
		width: 453,
		[BreakPoints.forMinWidth(768)]: {
			padding: '16px 0 0',
		},
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	inputWrap: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		marginBottom: 20,
		width: '100%',

		maxWidth: 453,
		padding: '0 20px',
		margin: '0 auto',
		boxSizing: 'border-box',
		[BreakPoints.forMinWidth(768)]: {
			padding: '16px 0 0',
		},
	},
	inputWrapHeader: {
		alignItems: 'center',
		display: 'flex',
		position: 'relative',
		justifyContent: 'space-between',
	},
	feedbackInput: {
		height: 75,
		resize: 'none',
	},
	feedbackLabel: {
		marginBottom: 14,
	},
	textInput: {
		height: 50,
		resize: 'none',
		...CssSelectors.allChildren(
			{
				height: '100%',
			},
			'textarea'
		),
	},
	footer: {
		display: 'flex',
		justifyContent: 'center',
		gap: 8,
		paddingBottom: 48,
		paddingTop: 32,
	},
	thankyou: {
		paddingTop: 32,
	},
	cancel: {
		border: `1px solid ${brandPrimary}`,
		color: brandPrimary,
		padding: '8px 16px',
		borderRadius: 8,
	},
	smallText: {
		color: charmGray,
		flexShrink: 0,
		position: 'absolute',
		right: 0,
		bottom: '100%',
	},
	selectBoxtriggerButton: {
		display: 'flex',
		width: '100%',
		border: `1px solid ${charmGray}`,
		background: hexToRGBA(borderColor, 0.3),
		borderRadius: 8,
		padding: 8,
		justifyContent: 'space-between',
		alignItems: 'center',
		...CssSelectors.allChildren(
			{
				display: 'block',
			},
			'img'
		),
		...CssSelectors.allChildren(
			{
				display: 'block',
			},
			'span'
		),
	},
	selectBoxtriggerButtonIsOpen: {
		...CssSelectors.allChildren(
			{
				transform: 'rotate(180deg)',
			},
			'img'
		),
	},
	dropdownContent: {
		boxSizing: 'border-box',
		borderRadius: 8,
		padding: 8,
		maxHeight: 200,
		overflowY: 'auto',
		width: '100%',
		minWidth: 316,
		...CssSelectors.allChildren(
			{
				display: 'block',
				padding: 8,
				width: '100%',
			},
			'button'
		),
	},
	dropdownButton: {
		background: white,
		color: titles,
		':hover': {
			background: brandPrimary,
			color: white,
		},
	},
	checkbox: {
		gap: 8,
		fontSize: 14,
		color: titles,
		textAlign: 'left',
	},
	errorMessage: {
		color: destructive,
		margin: 0,
		fontSize: 12,
		textAlign: 'left',
		maxWidth: 316,
	},
});
